import React from 'react';
import { ViewModule } from '@mui/icons-material';
import { colors } from '../../../themes/technicalAlerts';
import { UnifiedDropdown } from '../Shared/DropdownComponents';

/**
 * Grouping strategy control for cards view
 * Allows users to select how alerts are grouped (by store, machine, product, time)
 * Extracted from TechnicalAlertsTable.jsx for better component separation
 */
const GroupingControl = ({
  groupingStrategy,
  groupingStrategyLabels,
  showGroupingDropdown,
  onToggleGroupingDropdown,
  onGroupingStrategyChange,
  t
}) => {
  const groupingOptions = [
    { value: 'store_cluster', label: 'Ubicación' },
    { value: 'machine', label: t('machine') },
    { value: 'product', label: t('product') },
    { value: 'temporal', label: t('time') }
  ];

  return (
    <UnifiedDropdown
      data-grouping-control
      type="simple"
      isOpen={showGroupingDropdown}
      onClick={onToggleGroupingDropdown}
      onClose={onToggleGroupingDropdown}
      icon={<ViewModule sx={{ fontSize: 14, color: colors.text.hint }} />}
      label={t('groupBy')}
      value={groupingStrategyLabels[groupingStrategy] || groupingStrategy}
      options={groupingOptions}
      selectedValue={groupingStrategy}
      onSelect={onGroupingStrategyChange}
      sx={{ gap: '8px' }}
    />
  );
};

export default GroupingControl;